import React from 'react';

const MyBlog = () => {
    return (
        <div className="my-5" id="blog">
            <h1 className="text-center">My Blog</h1>
            <h3 className="text-center">My Blog coming soon ...</h3>
        </div>
    );
};

export default MyBlog;